import { authenticated } from '../../helpers/auth-header';
import insighttAPI from '../clients/insightt-api-client';
import { checklistEndpoints } from '../endpoints';

const getChecklist = (roleId, category) =>
  authenticated(insighttAPI).get(checklistEndpoints.getChecklistAPI(roleId, category));

const getChecklistByCategory = (category) =>
  authenticated(insighttAPI).get(checklistEndpoints.getCheckListCategory(category));

const createChecklistItem = (payload) =>
  authenticated(insighttAPI).post(checklistEndpoints.createChecklistItemAPI(), payload);

const createChecklistItemsMultiple = (payload) =>
  authenticated(insighttAPI).post(checklistEndpoints.createChecklistItemsMultipleAPI(), payload);

const editChecklistItem = (checklistItemId, payload) =>
  authenticated(insighttAPI).put(checklistEndpoints.editChecklistItemAPI(checklistItemId), payload);

const deleteChecklistItem = (checklistItemId) =>
  authenticated(insighttAPI).delete(checklistEndpoints.deleteChecklistItemAPI(checklistItemId));

const submitUserNTChecklist = (payload) =>
  authenticated(insighttAPI).post(checklistEndpoints.submitUserNTChecklistAPI(), payload);

const fetchUserChecklist = (id) => authenticated(insighttAPI).get(checklistEndpoints.fetchUserChecklistAPI(id));

const getUserNTChecklist = (userId) =>
  authenticated(insighttAPI).get(checklistEndpoints.getUserNTChecklistAPI(userId));

const submitUserShiftChecklist = (payload) =>
  authenticated(insighttAPI).post(checklistEndpoints.submitUserShiftChecklistAPI(), payload);

const getUserShiftChecklist = (userId, shiftTimeId, category) =>
  authenticated(insighttAPI).get(checklistEndpoints.getUserShiftChecklistAPI(userId, shiftTimeId, category));

const getTodoChecklist = () => authenticated(insighttAPI).get(checklistEndpoints.getTodoChecklistAPI());

const submitTodoChecklist = (checklistId, payload) =>
  authenticated(insighttAPI).put(checklistEndpoints.submitTodoChecklistAPI(checklistId), payload);

const updateChecklistComment = (commentId, payload) =>
  authenticated(insighttAPI).put(checklistEndpoints.updateChecklistCommentAPI(commentId), payload);

const deleteChecklistComment = (commentId) =>
  authenticated(insighttAPI).delete(checklistEndpoints.deleteChecklistCommentAPI(commentId));

export const checklistService = {
  getChecklist,
  createChecklistItem,
  createChecklistItemsMultiple,
  editChecklistItem,
  deleteChecklistItem,
  submitUserNTChecklist,
  fetchUserChecklist,
  getUserNTChecklist,
  submitUserShiftChecklist,
  getUserShiftChecklist,
  getTodoChecklist,
  submitTodoChecklist,
  updateChecklistComment,
  deleteChecklistComment,
  getChecklistByCategory,
};
